function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_214",
  "data-name": "Group 214"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_213",
  "data-name": "Group 213"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  className: "cls-1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_215",
  "data-name": "Group 215",
  transform: "translate(28.306 35.916)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_28",
  "data-name": "Ellipse 28",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_216",
  "data-name": "Group 216",
  transform: "translate(30.053 13.846)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_29",
  "data-name": "Ellipse 29",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_217",
  "data-name": "Group 217",
  transform: "translate(27.738 10.54)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_30",
  "data-name": "Ellipse 30",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_218",
  "data-name": "Group 218",
  transform: "translate(27.284 29.409)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_31",
  "data-name": "Ellipse 31",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_219",
  "data-name": "Group 219",
  transform: "translate(38.519 22.665)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_220",
  "data-name": "Group 220",
  transform: "translate(18.846 18.571)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_221",
  "data-name": "Group 221",
  transform: "translate(15.816 33.201)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_34",
  "data-name": "Ellipse 34",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "Group_222",
  "data-name": "Group 222",
  transform: "translate(12.136 16.724)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_35",
  "data-name": "Ellipse 35",
  className: "cls-1",
  cx: 1.025,
  cy: 1.025,
  r: 1.025
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Group_223",
  "data-name": "Group 223",
  transform: "translate(0 0.036)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  className: "cls-1",
  d: "M61.759,50.771,49.738,41.965a3.917,3.917,0,0,0-.69-4.6l-1.982-1.982a24.377,24.377,0,0,0,1.224-3.173.953.953,0,0,0-1.822-.558,22.817,22.817,0,1,1,.863-4.183.953.953,0,1,0,1.894.209A24.689,24.689,0,0,0,7.231,7.5,24.7,24.7,0,0,0,35.122,47.349L37.1,49.322a3.913,3.913,0,0,0,4.637.669l8.79,12a7.982,7.982,0,0,0,2.192,2.045.953.953,0,1,0,1.016-1.612,6.087,6.087,0,0,1-1.671-1.559l-8.87-12.108,5.325-5.325,12.117,8.877a6.117,6.117,0,0,1-2,10.834l-.023.006a6.128,6.128,0,0,1-1.115.2.953.953,0,0,0,.077,1.9q.039,0,.079,0a8.056,8.056,0,0,0,1.462-.258l.023-.006a8.023,8.023,0,0,0,2.626-14.21ZM47.7,41.551l-5.506,5.506-.917.917a2,2,0,0,1-2.834,0L36.9,46.429a24.825,24.825,0,0,0,9.25-9.265L47.7,38.717a2.006,2.006,0,0,1,0,2.834Z",
  transform: "translate(0 -0.285)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  className: "cls-1",
  d: "M63.752,44.881a19.065,19.065,0,1,0,13.481,5.584A18.941,18.941,0,0,0,63.752,44.881Zm12.13,31.2a17.146,17.146,0,1,1,0-24.259A17.173,17.173,0,0,1,75.882,76.076Z",
  transform: "translate(-38.995 -39.2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  className: "cls-1",
  d: "M95.328,167.213l-.01-.023a4.6,4.6,0,0,0-.567-.877,2.037,2.037,0,0,1-.391-.638,3.8,3.8,0,0,1-.025-1.14,3.913,3.913,0,0,0-.4-2.448,2.912,2.912,0,0,0-2.789-1.49,3.324,3.324,0,0,0-2.749,2.2,6.344,6.344,0,0,0-.31,2.8,11.11,11.11,0,0,0,.875,3.373,3.967,3.967,0,0,0,2.929,2.6,3.214,3.214,0,0,0,.492.038,3.278,3.278,0,0,0,2.569-1.231A3.2,3.2,0,0,0,95.328,167.213ZM93.442,169.2a1.348,1.348,0,0,1-1.26.479c-.7-.109-1.2-.881-1.486-1.51a9.09,9.09,0,0,1-.708-2.75,4.468,4.468,0,0,1,.2-1.959,1.427,1.427,0,0,1,1.135-.958c.031,0,.061,0,.091,0a1.029,1.029,0,0,1,.882.576,2.228,2.228,0,0,1,.133,1.326,5.377,5.377,0,0,0,.076,1.736,3.6,3.6,0,0,0,.731,1.344,3.092,3.092,0,0,1,.349.517l0,.005A1.3,1.3,0,0,1,93.442,169.2Z",
  transform: "translate(-76.87 -140.235)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  className: "cls-1",
  d: "M172.9,157.183a6.348,6.348,0,0,0-2.581,1.123c-.459.323-4.451,3.245-3.288,6.272a3.286,3.286,0,0,0,2.558,2.061,2.77,2.77,0,0,0,.389.027,3.217,3.217,0,0,0,2.539-1.271h0l.014-.02h0a4.6,4.6,0,0,0,.478-.928,2.043,2.043,0,0,1,.358-.657,3.8,3.8,0,0,1,.977-.589,3.914,3.914,0,0,0,1.924-1.566,2.912,2.912,0,0,0-.1-3.161A3.325,3.325,0,0,0,172.9,157.183Zm1.7,3.52a2.228,2.228,0,0,1-1.084.775,5.378,5.378,0,0,0-1.468.929,3.6,3.6,0,0,0-.8,1.3,3.08,3.08,0,0,1-.276.561l0,0h0a1.3,1.3,0,0,1-1.112.471,1.348,1.348,0,0,1-1.042-.854,2.391,2.391,0,0,1,.57-2.041,9.093,9.093,0,0,1,2.033-1.983,4.467,4.467,0,0,1,1.8-.8,1.428,1.428,0,0,1,1.4.508A1.008,1.008,0,0,1,174.6,160.7Z",
  transform: "translate(-145.639 -137.22)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  className: "cls-1",
  d: "M130.546,90.286l.025,0a4.609,4.609,0,0,0,1.043-.05,2.043,2.043,0,0,1,.748-.018,3.8,3.8,0,0,1,1,.551,3.951,3.951,0,0,0,2.274.882h.045a2.912,2.912,0,0,0,2.689-1.665,3.324,3.324,0,0,0-.521-3.481,6.346,6.346,0,0,0-2.264-1.673,11.117,11.117,0,0,0-3.356-.936,3.965,3.965,0,0,0-3.719,1.229,3.286,3.286,0,0,0-.5,3.246,3.2,3.2,0,0,0,2.543,1.913Zm-.553-3.958a2.392,2.392,0,0,1,2.052-.527,9.092,9.092,0,0,1,2.734.768,4.469,4.469,0,0,1,1.594,1.157,1.427,1.427,0,0,1,.258,1.462,1.008,1.008,0,0,1-.982.554,2.242,2.242,0,0,1-1.213-.551,5.375,5.375,0,0,0-1.539-.806,2.738,2.738,0,0,0-.775-.1,5.73,5.73,0,0,0-.755.063,3.077,3.077,0,0,1-.625.042h0a1.305,1.305,0,0,1-.964-.727A1.348,1.348,0,0,1,129.993,86.329Z",
  transform: "translate(-111.557 -73.254)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  "data-name": "Path 69",
  className: "cls-1",
  d: "M252.163,192.458a3.285,3.285,0,0,0-3.285.038,3.2,3.2,0,0,0-1.468,2.824v.025a4.6,4.6,0,0,0,.222,1.02,2.042,2.042,0,0,1,.141.735,3.8,3.8,0,0,1-.379,1.076,3.915,3.915,0,0,0-.488,2.432,2.912,2.912,0,0,0,2.085,2.377,3.023,3.023,0,0,0,.8.106,3.406,3.406,0,0,0,2.549-1.194,6.349,6.349,0,0,0,1.277-2.509,11.116,11.116,0,0,0,.37-3.465A3.966,3.966,0,0,0,252.163,192.458Zm-.388,6.425a4.47,4.47,0,0,1-.878,1.763,1.427,1.427,0,0,1-1.4.5,1.008,1.008,0,0,1-.709-.877,2.229,2.229,0,0,1,.343-1.288,5.381,5.381,0,0,0,.541-1.651,3.6,3.6,0,0,0-.21-1.516,3.067,3.067,0,0,1-.145-.613v0a1.305,1.305,0,0,1,.558-1.069,1.348,1.348,0,0,1,1.348,0,2.39,2.39,0,0,1,.858,1.937A9.1,9.1,0,0,1,251.775,198.883Z",
  transform: "translate(-215.515 -167.694)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  className: "cls-1",
  d: "M152.587,253.9a3.663,3.663,0,1,0,3.663,3.663A3.667,3.667,0,0,0,152.587,253.9Zm0,5.416a1.752,1.752,0,1,1,1.752-1.752A1.754,1.754,0,0,1,152.587,259.313Z",
  transform: "translate(-130.014 -221.694)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  className: "cls-1",
  d: "M246.157,122.676a3.663,3.663,0,1,0,3.663-3.663,3.668,3.668,0,0,0-3.663,3.663Zm5.416,0a1.752,1.752,0,1,1-1.752-1.752A1.754,1.754,0,0,1,251.573,122.676Z",
  transform: "translate(-214.9 -103.937)"
}));

var SvgDrugs = function SvgDrugs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041C\\u043E\\u043D\\u0456\\u0442\\u043E\\u0440\\u0438\\u043D\\u0433",
    width: 65.036,
    height: 65,
    viewBox: "0 0 65.036 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrugs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drugs.68bcbf5a.svg";
export { ForwardRef as ReactComponent };